var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOspPop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 110,
    viewBox: "0 0 256 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "osp"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "60.97 63.69 71.77 33.4 129.45 33.4 123.92 63.42 60.97 63.69",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.72
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.71 71.85 249.29 71.85 216.37 43.67 129.71 43.67 124.71 71.85",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.72
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129.45,
    y1: 33.4,
    x2: 133.93,
    y2: 42.88,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.72
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "62.81 63.95 62.81 93.71 117.33 93.71 117.33 67.11 95.73 67.11 95.73 93.19",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.72
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "124.71 92.92 246.4 92.92 246.4 72.12",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.72
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "123.92 63.42 123.92 93.45 117.33 93.45",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.72
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "89.94 93.19 89.94 66.58 69.13 66.58 69.13 92.92",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.72
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129.71,
    y1: 91.61,
    x2: 129.71,
    y2: 72.64,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.72
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "148.15 72.91 148.15 92.13 134.98 108.46 246.66 108.46",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.72
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "191.61 92.66 191.61 77.38 197.67 77.38 197.67 93.19",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.72
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "131.29 36.29 131.29 17.86 145.52 8.9 158.95 17.59 158.95 43.14",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.72
  }), /*#__PURE__*/React.createElement("line", {
    x1: 131.29,
    y1: 17.86,
    x2: 158.95,
    y2: 17.86,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.72
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.15,
    y: 23.39,
    width: 2.9,
    height: 2.9,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.72
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.43,
    y: 78.96,
    width: 5.53,
    height: 11.59,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.72
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.87,
    y: 80.54,
    width: 2.63,
    height: 1.58,
    fill: "#e77500",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.62,
    y: 80.54,
    width: 2.63,
    height: 1.58,
    fill: "#e77500",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.69,
    y: 73.25,
    width: 4.44,
    height: 2.66,
    fill: "#e77500",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.53,
    y: 73.25,
    width: 4.44,
    height: 2.66,
    fill: "#e77500",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.37,
    y: 73.25,
    width: 4.44,
    height: 2.66,
    fill: "#e77500",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.21,
    y: 73.25,
    width: 4.44,
    height: 2.66,
    fill: "#e77500",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.89,
    y: 73.14,
    width: 4.05,
    height: 2.88,
    fill: "#e77500",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.27,
    y: 73.14,
    width: 4.05,
    height: 2.88,
    fill: "#e77500",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.65,
    y: 73.14,
    width: 4.05,
    height: 2.88,
    fill: "#e77500",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.03,
    y: 73.14,
    width: 4.05,
    height: 2.88,
    fill: "#e77500",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("line", {
    x1: 143.94,
    y1: 7.85,
    x2: 147.36,
    y2: 7.85,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.72
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "62.81 93.71 32.52 108.2 6.71 108.2",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.72
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOspPop);
export default __webpack_public_path__ + "static/media/osp_pop.3cad8437a4da2d0be0e01f517e686b05.svg";
export { ForwardRef as ReactComponent };